import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Pagination from './Pagination';
import axios from 'axios';

function ArticleTablePinus() {
    const [articles, setArticles] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [isNarrowScreen, setIsNarrowScreen] = useState(window.innerWidth <= 480);

    // 화면 크기에 따른 상태 업데이트
    useEffect(() => {
        const checkScreenSize = () => {
            setIsNarrowScreen(window.innerWidth <= 490);
        };
        window.addEventListener('resize', checkScreenSize);
        return () => {
            window.removeEventListener('resize', checkScreenSize);
        };
    }, []);

    useEffect(() => {
        axios.get('https://disease.scnu.ac.kr/pinewilt')
            .then(res => {
                const reversedData = res.data.reverse(); // 역순 정렬
                setArticles(reversedData);
            })
            .catch(err => {
                console.error("Axios error:", err);
            });
    }, []);

    // 페이지네이션을 위한 변수 계산
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = articles.slice(indexOfFirstItem, indexOfLastItem);
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // 각 게시글을 클릭했을 때 새 탭에서 실행될 함수
    const handleClick = (article) => {
        const newWindow = window.open();
        newWindow.opener = null;
        newWindow.location = article.link;
    };

    // 날짜 형식 변환 함수
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        // 좁은 화면 여부 상관없이 항상 YYYY-MM-DD 형식으로 출력
        return `${year}-${month}-${day}`;
    };

    return (
        <div className="card has-table">
            {/*<button className="mdi mdi-refresh" onClick={handleButtonClick}> update naver news</button>*/}
            <div className="card-content">
                <table>
                    <thead>
                    <tr>
                        <th>Date</th>
                        <th>Title</th>
                        <th>Source</th>
                        <th>Summary</th>
                    </tr>
                    </thead>
                    <tbody>
                    {currentItems.map(article => (
                        <tr key={article.number}>
                            <td>{formatDate(article.date)}</td>
                            <td onClick={() => handleClick(article)} style={{ cursor: 'pointer' }}>
                                {article.title}
                            </td>
                            <td onClick={() => handleClick(article)} style={{ cursor: 'pointer' }}>
                                {article.source}
                            </td>
                            <td onClick={() => handleClick(article)} style={{ cursor: 'pointer' }}>
                                {article.contents}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                <Pagination
                    itemsPerPage={itemsPerPage}
                    totalItems={articles.length}
                    paginate={paginate}
                    currentPage={currentPage}
                />
            </div>
        </div>
    );
}

// Prop 유형 검증
Pagination.propTypes = {
    itemsPerPage: PropTypes.number.isRequired,
    totalItems: PropTypes.number.isRequired,
    paginate: PropTypes.func.isRequired,
};

export default ArticleTablePinus;
